import { Component, OnInit } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserApi } from 'src/shared/sdk/services';
import { Router } from "@angular/router";
import { LoopBackConfig } from "../../shared/sdk/index";
import { BASE_URL, API_VERSION } from "../../shared/base.url";


@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit {
  isRegistered;
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches)
    );

  constructor(
    private breakpointObserver: BreakpointObserver,
    public userApi: UserApi,
    private router: Router
  ) {
  }
  ngOnInit() {
    LoopBackConfig.setBaseURL(BASE_URL);
    LoopBackConfig.setApiVersion(API_VERSION);
  }
  
  logOut() {
    this.userApi.logout().subscribe(() => {
      this.router.navigate(["/"]);
    });
  }
}
